function OverrideCounterBidingTooltip() {
  return (
    <>
      <span>Controls the counter bidding behavior for this CLink.</span>
      <ul>
        <li>Default - Based on current publisher and/or campaign configuration or hydrate parameter setting</li>
        <li>Allow - Enables counter bidding regardless of publisher/campaign configuration or hydrate parameter</li>
        <li>Disable - Counter bidding is disabled, regardless of any other configuration or hydrate setting</li>
        <li>The admin Allow/Disable setting will override the partner setting</li>
      </ul>
    </>
  );
}

export default OverrideCounterBidingTooltip;